import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-285f94f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "orders font-inter pb-10 mb-10 lg:py-6 enter-content-animation px-4 md:px-0 sm:pt-10 pt-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-6 flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold" }, "Pedidos em andamento")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "orders__orders-list grid grid-cols-12 gap-4"
}
const _hoisted_4 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_5 = { class: "h-16 w-16 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  class: "text-gray-400"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M3 6h18" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M16 10a4 4 0 0 1-8 0" }, null, -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "text-semibold text-base font-bold text-gray-800 line-clamp-1" }
const _hoisted_13 = { class: "text-xs text-gray-400" }
const _hoisted_14 = { class: "flex flex-col gap-3 py-2 border-t border-dashed mt-2" }
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = { class: "flex items-center gap-2 text-gray-600" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-285f94f8><path d=\"m7.5 4.27 9 5.15\" data-v-285f94f8></path><path d=\"M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z\" data-v-285f94f8></path><path d=\"m3.3 7 8.7 5 8.7-5\" data-v-285f94f8></path><path d=\"M12 22V12\" data-v-285f94f8></path></svg>", 1)
const _hoisted_18 = { class: "text-sm font-medium" }
const _hoisted_19 = { class: "font-bold text-primary" }
const _hoisted_20 = {
  key: 0,
  class: "flex items-center gap-2 text-gray-600"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 3h18v18H3z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 9h18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M9 3v18" })
], -1))
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = {
  key: 0,
  class: "text-xs opacity-60"
}
const _hoisted_24 = { class: "flex items-center justify-between mt-2" }
const _hoisted_25 = { class: "text-xs flex items-center gap-2 text-gray-400 uppercase font-bold" }
const _hoisted_26 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "1",
  y: "3",
  width: "15",
  height: "13"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "16 8 20 8 23 11 23 16 16 16" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "5.5",
  cy: "18.5",
  r: "2.5"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "18.5",
  cy: "18.5",
  r: "2.5"
}, null, -1))
const _hoisted_31 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "7",
  r: "4"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" }, null, -1))
const _hoisted_37 = [
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m9 18 6-6-6-6" })
], -1))
const _hoisted_40 = {
  key: 1,
  class: "pt-20 flex flex-col items-center justify-center opacity-40"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"mb-4\" data-v-285f94f8><path d=\"M3 7V5c0-1.1.9-2 2-2h2\" data-v-285f94f8></path><path d=\"M17 3h2c1.1 0 2 .9 2 2v2\" data-v-285f94f8></path><path d=\"M21 17v2c0 1.1-.9 2-2 2h-2\" data-v-285f94f8></path><path d=\"M7 21H5c-1.1 0-2-.9-2-2v-2\" data-v-285f94f8></path><circle cx=\"12\" cy=\"12\" r=\"3\" data-v-285f94f8></circle><path d=\"m16 16-1.9-1.9\" data-v-285f94f8></path></svg><h5 class=\"font-semibold text-lg text-center\" data-v-285f94f8>Nenhum pedido em andamento</h5><p class=\"text-center text-sm\" data-v-285f94f8>Os pedidos aparecerão aqui assim que forem feitos.</p>", 3)
const _hoisted_44 = [
  _hoisted_41
]

import axiosClient from '@/api/axios';
import { onMounted, ref, watch } from 'vue';
import { apiBaseUrl, orders } from '@/global/state/GlobalState';
import OrdersShow from './OrdersShow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersView',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const selectedOrder = ref<any>(null)
const statusTranslations: any = {
    'PENDING': {label: 'pendente', color:'#918373'},
    'PREPARING': {label: 'preparando', color:'#FF9B3D'},
    'PREPARED': {label: 'preparado', color:'#59A6F8'},
    'DELIVERED': {label: 'entregue', color: '#00c9a7'},
    'CANCELED': {label: 'cancelado', color:'#F83535'},
    'COMPLETED': {label: 'concluído', color: '#00c9a7'},
}
const orderTypeTranslations: any = {
    'delivery': 'entrega',
    'waiter': 'presencial',
    'pick_up': 'retirada',
}

async function getOrders(){
    try {
        const res = await axiosClient.get('/orders')
        const fetchedOrders = res.data.data || res.data
        
        if (Array.isArray(fetchedOrders)) {
            orders.value = fetchedOrders
            
            if(props.id){
                selectedOrder.value = fetchedOrders.find((o: any) => o.id == props.id)
            }
        }
    } catch (error) {
        console.error('Error fetching orders:', error)
    }
}

function onOrderImageError(e: any){
    e.target.style.display = 'none'
}

onMounted(() => {
  getOrders()
})

watch(() => props.id, (newId) => {
    if (newId) {
        selectedOrder.value = orders.value.find((o: any) => o.id == newId)
    }
})

return (_ctx: any,_cache: any) => {
  return (!selectedOrder.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_unref(orders) && _unref(orders).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orders), (order) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "box-shadow p-6 rounded-2xl col-span-12 sm:col-span-6 lg:col-span-4 relative border bg-white hover:border-primary transition duration-300",
                  key: order.id
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({background: statusTranslations[order.status]?.color}),
                    class: "absolute top-0 right-0 text-white text-[10px] uppercase font-bold p-2 px-3 rounded-tr-xl rounded-bl-xl"
                  }, _toDisplayString(statusTranslations[order.status]?.label), 5),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (order.items?.[0]?.product?.media?.[0])
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "h-full w-full object-cover",
                            src: _unref(apiBaseUrl) + '/storage/' + order.items[0].product.media[0].path,
                            onError: onOrderImageError
                          }, null, 40, _hoisted_6))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_11))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(order.items?.[0]?.product?.name || 'Pedido sem itens'), 1),
                      _createElementVNode("p", _hoisted_13, "#" + _toDisplayString(order.id) + ", às " + _toDisplayString(new Date(order.createdAt).toLocaleTimeString('pt-BR').slice(0, 5)) + "h", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("span", _hoisted_18, _toDisplayString(order.items?.length || 0) + " " + _toDisplayString((order.items?.length || 0) > 1 ? 'itens' : 'item'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(order.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                    ]),
                    (order.tab)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("p", _hoisted_22, [
                            _createTextVNode("Mesa " + _toDisplayString(order.tab.number) + " ", 1),
                            (order.tab.name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "(" + _toDisplayString(order.tab.name) + ")", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        (order.type === 'delivery')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_31))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_37)),
                        _createElementVNode("span", null, _toDisplayString(orderTypeTranslations[order.type]), 1)
                      ]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (selectedOrder.value = order),
                        class: "text-xs text-primary font-bold flex items-center gap-1 hover:underline transition transition-all duration-200"
                      }, [
                        _createTextVNode(" DETALHES "),
                        _hoisted_39
                      ], 8, _hoisted_38)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_44))
      ]))
    : (_openBlock(), _createBlock(OrdersShow, {
        key: 1,
        order: selectedOrder.value,
        setOrder: (value) => selectedOrder.value = value
      }, null, 8, ["order", "setOrder"]))
}
}

})